var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDobExact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.71094,
    y: 3.65625,
    width: 16.5856,
    height: 16.5856,
    rx: 2.11724,
    fill: "#3158F2",
    stroke: "#3158F2",
    strokeWidth: 1.65856,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 9H21",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0127 12.7266C11.8747 12.7266 11.7627 12.8386 11.7637 12.9766C11.7637 13.1146 11.8757 13.2266 12.0137 13.2266C12.1517 13.2266 12.2637 13.1146 12.2637 12.9766C12.2637 12.8386 12.1517 12.7266 12.0127 12.7266",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01268 12.7266C6.87468 12.7266 6.76268 12.8386 6.76368 12.9766C6.76368 13.1146 6.87568 13.2266 7.01368 13.2266C7.15168 13.2266 7.26368 13.1146 7.26368 12.9766C7.26368 12.8386 7.15168 12.7266 7.01268 12.7266",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0127 12.7266C16.8747 12.7266 16.7627 12.8386 16.7637 12.9766C16.7637 13.1146 16.8757 13.2266 17.0137 13.2266C17.1517 13.2266 17.2637 13.1146 17.2637 12.9766C17.2637 12.8386 17.1517 12.7266 17.0127 12.7266",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01268 16.7266C6.87468 16.7266 6.76268 16.8386 6.76368 16.9766C6.76368 17.1146 6.87568 17.2266 7.01368 17.2266C7.15168 17.2266 7.26368 17.1146 7.26368 16.9766C7.26368 16.8386 7.15168 16.7266 7.01268 16.7266",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0127 16.7266C11.8747 16.7266 11.7627 16.8386 11.7637 16.9766C11.7637 17.1146 11.8757 17.2266 12.0137 17.2266C12.1517 17.2266 12.2637 17.1146 12.2637 16.9766C12.2637 16.8386 12.1517 16.7266 12.0127 16.7266",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0127 16.7266C16.8747 16.7266 16.7627 16.8386 16.7637 16.9766C16.7637 17.1146 16.8757 17.2266 17.0137 17.2266C17.1517 17.2266 17.2637 17.1146 17.2637 16.9766C17.2637 16.8386 17.1517 16.7266 17.0127 16.7266",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.43808 2V3.65856V2Z",
    fill: "#3158F2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43808 2V3.65856",
    stroke: "#3158F2",
    strokeWidth: 1.65856,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5553 2V3.65856V2Z",
    fill: "#3158F2"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5553 2V3.65856",
    stroke: "#3158F2",
    strokeWidth: 1.65856,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDobExact);
export default __webpack_public_path__ + "static/media/dob-exact.983badeeeb01d645195b125c9f462316.svg";
export { ForwardRef as ReactComponent };